import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["title"];
const _hoisted_2 = { class: "ta-c" };
const _hoisted_3 = { class: "ta-c" };
import { routeName } from '@/constants/routeName';
import { autoLcWorkerNotice } from '@/locales/ko/views/worker_notice';
import { useRouter } from 'vue-router';
import dateFormatType from '@/constants/dateFormatType';
import { isTodayTextColor, formatDate, } from '@/utils';
import { prevData } from '@/pinia/workerNotice';
import { pStore } from '@/pinia';
export default /*@__PURE__*/ _defineComponent({
    __name: 'Item',
    props: {
        item: {}
    },
    emits: ["onDelete"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emits = __emit;
        const router = useRouter();
        const lc = autoLcWorkerNotice();
        const to = () => ({
            name: routeName.WORKER_NOTICE_DETAIL,
            params: {
                workerNoticeId: props.item.id,
            },
        });
        /**
         * 링크 클릭 핸들러
         */
        const handleClickLink = () => {
            // 현재 페이지네이션 번호 저장
            prevData.pageNumber = pStore.piniaWorkerNotice.filterOption.pageNumber;
        };
        /**
         * 삭제 핸들러
         */
        const handleClickDeleteBtn = () => {
            emits('onDelete', props.item.id);
        };
        /**
         * 수정 클릭 핸들러
         */
        const handleClickEditBtn = () => {
            const name = routeName.WORKER_NOTICE_EDIT;
            const value = {
                params: {
                    workerNoticeId: props.item.id,
                },
            };
            router.push({
                name,
                ...value,
            }).catch(() => { });
        };
        return (_ctx, _cache) => {
            const _component_router_link = _resolveComponent("router-link");
            const _component_v_icon = _resolveComponent("v-icon");
            const _component_v_btn = _resolveComponent("v-btn");
            const _directive_btn_style = _resolveDirective("btn-style");
            return (_openBlock(), _createElementBlock("tr", {
                class: _normalizeClass(`cy-item-${props.item.id}`)
            }, [
                _createElementVNode("td", null, _toDisplayString(props.item.id), 1 /* TEXT */),
                _createElementVNode("td", null, [
                    _createVNode(_component_router_link, {
                        class: "cy-link",
                        to: to(),
                        onClick: _cache[0] || (_cache[0] = ($event) => (handleClickLink()))
                    }, {
                        default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(props.item.title), 1 /* TEXT */)
                        ]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["to"])
                ]),
                _createElementVNode("td", {
                    class: "ta-c text-ellipsis",
                    title: props.item.userName
                }, _toDisplayString(props.item.userName), 9 /* TEXT, PROPS */, _hoisted_1),
                _createElementVNode("td", _hoisted_2, [
                    _createElementVNode("span", {
                        class: _normalizeClass(_unref(isTodayTextColor)(props.item.createdAt))
                    }, _toDisplayString(_unref(formatDate)(props.item.createdAt, _unref(dateFormatType).FULL_DATE_MINUTE)), 3 /* TEXT, CLASS */)
                ]),
                _createElementVNode("td", _hoisted_3, [
                    _withDirectives((_openBlock(), _createBlock(_component_v_btn, { onClick: handleClickEditBtn }, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_icon, { small: "" }, {
                                default: _withCtx(() => _cache[1] || (_cache[1] = [
                                    _createTextVNode(" mdi-pencil-outline ")
                                ])),
                                _: 1 /* STABLE */,
                                __: [1]
                            }),
                            _createElementVNode("span", null, _toDisplayString(_unref(lc)('edit')), 1 /* TEXT */)
                        ]),
                        _: 1 /* STABLE */
                    })), [
                        [
                            _directive_btn_style,
                            void 0,
                            "config",
                            {
                                info: true,
                                outlined: true,
                                "size-xs": true
                            }
                        ]
                    ]),
                    _withDirectives((_openBlock(), _createBlock(_component_v_btn, {
                        class: "cy-delete-btn ml-1",
                        onClick: handleClickDeleteBtn
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_icon, { small: "" }, {
                                default: _withCtx(() => _cache[2] || (_cache[2] = [
                                    _createTextVNode(" mdi-trash-can-outline ")
                                ])),
                                _: 1 /* STABLE */,
                                __: [2]
                            }),
                            _createTextVNode(" " + _toDisplayString(_unref(lc)('delete')), 1 /* TEXT */)
                        ]),
                        _: 1 /* STABLE */
                    })), [
                        [
                            _directive_btn_style,
                            void 0,
                            "config",
                            {
                                info: true,
                                outlined: true,
                                "size-xs": true
                            }
                        ]
                    ])
                ])
            ], 2 /* CLASS */));
        };
    }
});
